import React from 'react'

const InteriorDashboard = ({ width = '64px', height = '64px', color }) => (
  <svg version={1.1} id="Layer_1" x="0" y="0" viewBox="0 0 960 719" width="100px" height={height} xmlSpace="preserve">
    <g>
      <path
        fill="none"
        stroke={color}
        strokeWidth="9.35"
        strokeMiterlimit="10"
        d="M706.5,239.1c-21.4,0-41.6,4.9-59.7,13.8c4,14.6,5.9,29.8,6,44.9l0,0C653.1,351,627,403.2,584.3,435
		c58.9,127,260.5,82.6,258.2-59.8C842.5,300,781.6,239.1,706.5,239.1z"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth="9.35"
        strokeMiterlimit="10"
        d="M361.8,420.9c-44.1-42-62.4-108.2-46.4-167c-86.7-46.8-200.4,21.7-197.8,121.2
		c-2.3,143.2,201,186.8,258.8,58.4C371.3,429.6,366.4,425.4,361.8,420.9z"
      />
      <path
        fill="none"
        stroke={color}
        strokeWidth="9.35"
        strokeMiterlimit="10"
        d="M588.6,431.6c52.6-41.3,76.4-114.4,58.3-178.7l0,0C606,86.4,355.1,87.2,315.3,254l0,0
		C273.9,413.5,459.8,534.2,588.6,431.6z"
      />
    </g>
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M726.1,375.1c-0.5,26.7-40.2,26.7-40.6,0C686,348.4,725.7,348.4,726.1,375.1z" />
    <rect x="171" y="432.5" fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" width="151.9" height="25" />
    <rect x="629.9" y="432.5" fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" width="151.9" height="25" />
    <rect x="367.1" y="342.6" fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" width="233" height="42.9" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="826" y1="432.5" x2="799.2" y2="419.7" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="840.5" y1="370.5" x2="812.6" y2="370.5" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="826.6" y1="313.1" x2="806.3" y2="323.2" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="784.4" y1="263.5" x2="768.4" y2="279.5" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="480.5" y1="159.3" x2="480.5" y2="184.1" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="253.5" y1="245.3" x2="253.5" y2="270" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="707.5" y1="237.8" x2="707.5" y2="262.5" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="428.3" y1="169.4" x2="438.7" y2="190.4" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="377.3" y1="207.2" x2="398.8" y2="224.6" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="349.5" y1="255.1" x2="375.3" y2="265.1" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="340" y1="309.3" x2="367.1" y2="309.3" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="531.4" y1="169.4" x2="521" y2="190.4" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="582.4" y1="207.2" x2="560.9" y2="224.6" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="610.1" y1="255.1" x2="584.3" y2="265.1" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="619.7" y1="309.3" x2="592.5" y2="309.3" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="723.6" y1="364.1" x2="786.7" y2="332.8" />
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M231.9,375.6c0.5,26.7,40.2,26.7,40.6,0C272.1,348.9,232.4,348.9,231.9,375.6z" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="132" y1="433" x2="158.8" y2="420.1" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="117.5" y1="370.9" x2="145.4" y2="370.9" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="131.5" y1="313.6" x2="151.8" y2="323.6" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="173.7" y1="264" x2="189.7" y2="280" />
    <line fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" x1="234.5" y1="364.5" x2="171.4" y2="333.3" />
    <g>
      <path
        fill="none"
        stroke={color}
        strokeWidth="9.35"
        strokeMiterlimit="10"
        d="M481.2,150.7c-91.6-1.1-163,86.3-144.3,175.8h124c0.1-26.6,40.5-26.6,40.6,0h124
		C644.2,237,572.9,149.6,481.2,150.7z"
      />
    </g>
    <polygon fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" points="480.5,238.6 469.6,304.5 491.5,304.5 " />
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M464.5,416.2c0.2,12.9-20.1,12.9-19.9,0C444.5,403.3,464.7,403.3,464.5,416.2z" />
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M512.4,416.2c0.2,12.9-20.1,12.9-19.9,0C492.4,403.3,512.6,403.3,512.4,416.2z" />
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M560.3,416.2c0.2,12.9-20.1,12.9-19.9,0C540.2,403.3,560.5,403.3,560.3,416.2z" />
    <path fill="none" stroke={color} strokeWidth="9.35" strokeMiterlimit="10" d="M416.7,416.2c0.2,12.9-20.1,12.9-19.9,0C396.6,403.3,416.9,403.3,416.7,416.2z" />
    <path
      fill="none"
      stroke={color}
      strokeWidth="9.35"
      strokeMiterlimit="10"
      d="M899.8,334.6C877,24.9,81.3,25,58.7,334.7c-25.6,18.2-33.4,48-33.4,81.6c-6.3,60.2,26,122.7,91,121.8l44.5,6
	c77.4,58.1,191.4-1.1,318.5-1.1s241.1,60.2,318.5,2.1l44.6-7c64.9,0.9,98.6-61.4,92-121.8C934.3,382.6,925.5,352.7,899.8,334.6z"
    />
  </svg>
)
export default InteriorDashboard
